import { Parallax } from 'react-parallax';
import '../assets/styles/Hero.css';
import BotaoZap from './BotaoZap';
import imgHome from '../assets/images/fundo.avif';

export default function Hero() {
  return (
    <Parallax
      blur={0}
      bgImage={imgHome}
      bgImageAlt="Hero Background"
      strength={300}
      className="hero-parallax"
    >
      <section id="inicio" className="hero-section">
        <div className="hero-overlay" />
        <div className="hero-container">
          <h1>Multiserviços para Escolas, Residências e Empresas</h1>
          <h2>
            Emergências <span>24h</span>
          </h2>
          <p>
            Serviços <strong>Profissionais</strong> para manutenção elétrica, hidráulica,
            sistemas de alarme, câmeras de segurança, Instalação de Drywall, Reparos e muito mais.
          </p>
          <h2>
             Com <span>garantia</span> e <span>nota fiscal</span>
          </h2>
          <p>
            Confira todos os nossos serviços! <strong>Orçamento gratuito</strong>
          </p>
          <h3>
            <strong>RESPOSTA IMEDIATA</strong>
          </h3>
          <BotaoZap texto="Peça um orçamento" />
        </div>
      </section>
    </Parallax>
  );
}